/* External dependencies */
import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { Action } from 'redux';

/* Local dependencies */
import { createDeviceRequest } from './service';
import { CreateDeviceActionTypes, createDeviceFailure, createDeviceSuccess, CreateDeviceAction } from './acrions';
import { CreateDeviceInput, Device } from '../../types';
import { RootState } from '../../../../redux/store';
import { listDevice } from '../../list-device/redux/actions';

export const createDeviceEpic: Epic<Action, Action, RootState> = (action$) => {
  return action$.pipe(
    ofType(CreateDeviceActionTypes.CREATE_DEVICE_REQUEST),
    switchMap((action: CreateDeviceAction) =>
      from(createDeviceRequest(action.payload as CreateDeviceInput)).pipe(
        mergeMap((device: Device) => [createDeviceSuccess(device), listDevice()]),
        catchError((error) => {
          console.error('Error in createDeviceEpic:', error);
          return of(createDeviceFailure(error instanceof Error ? error.message : 'Failed to create device'));
        }),
      ),
    ),
  );
};
